@for (item of itemsByCategory(); let last = $last; track $index) {

  <h4 class="__category">{{ translations.serviceGroup[item.category] }}</h4>

  <div class="__grid">
    @for (item of item.items; track $index) {
      <div [attr.data-service-type-type]="item?.item?.id">

        <div class="__item-wrap">

          <button
            class="__tile"
            zui-service-stack-tile
            matRipple
            [matRippleColor]="'rgba(0, 0, 0, 0.02)'"
            [icon]="serviceStackCategoryMap()[item?.item?.id] === serviceStackCategories.Storage
              ? 'storage'
              : undefined"
            type="button"
            (click)="value = item?.item?.id; selected.emit(item?.item?.id)">

            <ng-container *zuiServiceStackTileCategory>
              {{ translations.serviceCategory[serviceStackCategoryTextMap()[item?.item?.id]] }}
              <!--
              <div *zuiFormSectionDesc>
                <zui-docs-text>
                  {{ translations.serviceCategory[serviceStackCategoryTextMap()[item?.item?.id]] }}
                </zui-docs-text>
              </div>
              -->
            </ng-container>

            <zef-fuse-highlight
              *zuiServiceStackTileName
              [data]="item?.item"
              [key]="'name'"
              [matches]="item?.matches">
            </zef-fuse-highlight>

          </button>

        </div>

      </div>
    }
  </div>

  @if (!last) {
    <zui-separator class="__search-sep" [position]="'start'" [spacing]="'medium'" [size]="'small'" />
  }
}
